import { render } from "./FieldsForm.vue?vue&type=template&id=b647cf5a"
import script from "./FieldsForm.vue?vue&type=script&lang=js"
export * from "./FieldsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__